module.exports = __webpack_public_path__ + "ace3d5b785f01689d46740d26b55d68a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/4.jpg
 ** module id = 218
 ** module chunks = 0
 **/